const isLocalInstance = window.location.origin.indexOf('localhost') !== -1;
let sentry;

function init(vue, dsn) {

  // FIXME: Sentry integration with Vue does not allow logging to developer console at the same time
  // Details:
  // -- https://github.com/getsentry/sentry-javascript/issues/1416
  // -- https://github.com/vuejs/vue/issues/8433
  // -- https://docs.sentry.io/platforms/javascript/vue/
  if (typeof Sentry === 'object' && !isLocalInstance) {
    Sentry.init({
      dsn: dsn,
      integrations: [new Sentry.Integrations.Vue({ vue })]
    });

    sentry = Sentry;
  }
}

function addUserInfo(userInfo) {
  if (sentry) {
    sentry.configureScope(scope => {
      scope.setUser(userInfo);
    });
  }
}

function error(err) {
  if (sentry) Sentry.captureException(err);
  else console.error(err);
}

export default {
  init,
  addUserInfo,
  error
}
